module.exports = __webpack_public_path__ + "static/media/smileBeam.514190df.svg";